<template>
  <div>
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>MDR报告</el-breadcrumb-item>
    </el-breadcrumb>

    <el-card class="search-item" shadow="never">
      <span>搜索条件</span>
    </el-card>

    <el-card class="search-form" shadow="never">
      <!-- 搜索表单 -->
        <el-form>
            <el-row>
                <el-col :span="4">
                    <el-row>
                        <el-col :span="7">
                            <el-form-item>
                                <label>大区</label>
                            </el-form-item>
                        </el-col>
                        <el-col :span="15">
                            <el-form-item>
                                <el-select v-model="searchList.areaId" filterable placeholder @change="areaChange">
                                    <el-option v-for="item in areaDDL"
                                               :key="item.value"
                                               :label="item.label"
                                               :value="item.value"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-col>
                <el-col :span="4">
                    <el-row>
                        <el-col :span="7">
                            <el-form-item>
                                <label>省区</label>
                            </el-form-item>
                        </el-col>
                        <el-col :span="15">
                            <el-form-item>
                                <el-select v-model="searchList.salegroupId" filterable placeholder @change="handleSelectChange">
                                    <el-option v-for="item in saleGroupDDL"
                                               :key="item.value"
                                               :label="item.label"
                                               :value="item.value"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-col>
                <el-col :span="4">
                    <el-row>
                        <el-col :span="7">
                            <el-form-item>
                                <label>月份</label>
                            </el-form-item>
                        </el-col>
                        <el-col :span="15">
                            <el-form-item>
                                <el-select v-model="searchList.month" filterable placeholder>
                                    <el-option v-for="item in monthDDL"
                                               :key="item.value"
                                               :label="item.label"
                                               :value="item.value"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-col>
                <el-col :span="4">
                    <el-row>
                        <el-col :span="7">
                            <el-form-item>
                                <label>年份</label>
                            </el-form-item>
                        </el-col>
                        <el-col :span="15">
                            <el-form-item>
                                <el-select v-model="searchList.year"
                                           filterable
                                           placeholder
                                           @change="handleSelectChange">
                                    <el-option v-for="item in yearDDL"
                                               :key="item.value"
                                               :label="item.label"
                                               :value="item.value"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-col>
                <el-col :span="8">
                    <el-row>
                        <el-col :span="6">
                            <el-form-item>
                                <el-button @click="getMdrReportList(true)" type="primary">搜索</el-button>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item>
                                <el-button type="primary" @click="resetSearch">重置</el-button>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item>
                                <el-button v-if="haveEditAccess"
                                           @click="editMDRReport"
                                           type="primary">编辑</el-button>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item>
                                <el-button v-if="haveEditAccess"
                                           @click="saveMDRChange"
                                           type="primary">保存</el-button>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="6" v-if="haveEditAccess">
                            <el-form-item>
                                <el-button @click="importDialogVisible = true" type="primary">导入</el-button>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item>
                                <el-button @click="exportMdrReportList()" type="primary">导出</el-button>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-col>
            </el-row>
            <el-row class="lastBtnRow">
                <el-col :span="8" :offset="16">
                    <el-row>

                    </el-row>
                </el-col>
            </el-row>
        </el-form>
    </el-card>

    <el-card class="search-item" shadow="never">
        <div style="display: flex; justify-content: space-between; align-items: center; width: 100%;">
            <span>查询结果</span>
            <span>
                总计：毛销售  {{ totalSales }}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;MDR总金额  {{ totalMdrAmount }}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;MDR%  {{ totalMdrAmountPercent }}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;消化返利终端总金额  {{ totalRebetaAmount }}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;消化返利终端%  {{ totalRebetaAmountPercent }}
            </span>
        </div>
    </el-card>
    <el-card class="result-table" shadow="never">
        <el-table :data="mdrReportList" border stripe height="520">
            <el-table-column prop="areaName" label="大区"></el-table-column>
            <el-table-column prop="saleGroupName" label="省区"></el-table-column>
            <el-table-column prop="monthLabel" label="月份"></el-table-column>
            <el-table-column prop="year" label="年份"></el-table-column>
            <el-table-column label="毛销售">
                <template slot-scope="scope">
                    <span v-if="!haveEditAccess"> {{scope.row.sales|thousandth}}</span>
                    <div class="el-input--small" v-if="haveEditAccess">
                        <currency-input v-model="scope.row.sales" class="el-input__inner currencyInput" @change="saleChange(scope.row)" :currency="null" v-bind:disabled="inputDisable || (scope.row.mdrTrackId < 1) "></currency-input>
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="MDR总金额">
                <template slot-scope="scope">
                    <span v-if="!haveEditAccess"> {{scope.row.mdrAmount|thousandth}}</span>
                    <div class="el-input--small" v-if="haveEditAccess">
                        <currency-input v-model="scope.row.mdrAmount" class="el-input__inner currencyInput" @change="mdrAmountChange(scope.row)" :currency="null" v-bind:disabled="inputDisable || (scope.row.mdrTrackId < 1) "></currency-input>
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="MDR%">
                <template slot-scope="scope">
                    <span>{{scope.row.mdrAmountPercent}}%</span>
                </template>
            </el-table-column>
            <el-table-column label="消化返利终端总金额">
                <template slot-scope="scope">
                    <span v-if="!haveEditAccess"> {{scope.row.rebatesReturnAmount|thousandth}}</span>
                    <div class="el-input--small" v-if="haveEditAccess">
                        <currency-input v-model="scope.row.rebatesReturnAmount" class="el-input__inner currencyInput" @change="rebataAmountChange(scope.row)" :currency="null" v-bind:disabled="inputDisable || (scope.row.mdrTrackId < 1) "></currency-input>
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="消化返利终端总金额%">
                <template slot-scope="scope">
                    <span> {{scope.row.rebatesReturnAmountPercent}}%</span>
                </template>
            </el-table-column>
        </el-table>

      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="queryInfo.pagenum"
        :page-sizes="[10, 20, 50]"
        :page-size="queryInfo.pagesize"
        layout="total, sizes, prev, pager, next, jumper"
        :hide-on-single-page="true"
        :total="listTotalNum"
      ></el-pagination>

      <el-dialog
        title="导入MDR报告数据"
        :visible.sync="importDialogVisible"
        width="40%"
        @close="importDialogClosed"
        :close-on-click-modal="false"
      >
        <el-form ref="importFormRef" label-width="100px">
          <el-form-item label="上传文件：">
            <el-upload
              class="upload"
              ref="upload"
              action
              :file-list="fileList"
              :multiple="false"
              :show-file-list="true"
              :limit="1"
              :auto-upload="false"
              accept=".xlsx"
            >
              <el-button slot="trigger" type="primary">选取文件</el-button>
              <div slot="tip" class="el-upload__tip">只能上传一个文件，需要先删除已选择的文件，然后重新选择</div>
            </el-upload>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="importDialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="submitUpload">确定上传</el-button>
        </span>
      </el-dialog>
    </el-card>
  </div>
</template>

<script>
    export default {
        data() {
            return {
                areaDDL: [],
                saleGroupDDL: [],
                monthDDL: [],
                yearDDL: [],
                searchList: {},
                queryInfo: {
                    query: "",
                    pagenum: 1,
                    pagesize: 10
                },
                listTotalNum: 0,
                totalSales : 0,
                totalMdrAmount: 0,
                totalMdrAmountPercent: 0,
                totalRebetaAmount: 0,
                totalRebetaAmountPercent: 0,
                mdrReportList: [],
                downloadFileName: "",
                fileList: [],
                currentYear: null,
                currentMonth: null,
                inputDisable: true,
                haveEditAccess: false,
                isLoginUserAsAreaMarket: false,
                importDialogVisible: false
            };
        },
        created() {
            this.getDDL();
            this.getCurrentDate();
            this.getMdrReportList(true);
            this.getLoginUserInfo();
        },
        methods: {
            async getDDL() {
                const { result: area } = await this.$http.get(
                    "/Home/GetSelectList?lookup=userArea"
                );
                const { result: saleGroup } = await this.$http.get(
                    "/Home/GetSelectList?lookup=salgegroup"
                );
                const { result: month } = await this.$http.get(
                    "/Home/GetSelectList?lookup=NormalMonth"
                );
                const { result: year } = await this.$http.get(
                    "/Home/GetSelectList?lookup=NormalYear"
                );
                this.areaDDL = area;
                this.saleGroupDDL = saleGroup;
                this.monthDDL = month;
                this.yearDDL = year;
            },
            async resetSearch() {
                this.searchList = [];
                this.searchList.year = this.currentYear;
                const { result: saleGroup } = await this.$http.get(
                    "/Home/GetSelectList?lookup=salgegroup"
                );
                this.saleGroupDDL = saleGroup;
            },
            async getLoginUserInfo() {
                const { result: res } = await this.$http.get("Home/GetUserInfo");
                if (!!res[0].loginId) {
                    var userRoleIds = res[0].roleIds.split(";");
                    var currentMenuId = window.sessionStorage.getItem("activeMenuId");
                    if (
                        userRoleIds.findIndex(e => e == 1) > -1 ||
                        userRoleIds.findIndex(e => e == 2) > -1
                    ) {
                        //系统管理员||价格经理
                        this.isLoginUserAsAreaMarket = false;
                    } else if (userRoleIds.findIndex(e => e == 3) > -1) {
                        //大区市场
                        this.isLoginUserAsAreaMarket = true;
                    }
                    //判断是否有edit权限
                    if (
                        res[0].pageAccess.findIndex(
                            e => e.menuId == currentMenuId && e.access == "modify"
                        ) > -1
                    ) {
                        this.haveEditAccess = true;
                    }
                }
            },
            async getMdrReportList(fromSearch) {
                if (fromSearch) {
                    this.queryInfo.pagenum = 1;
                }
                const { result: month } = await this.$http.get(
                    "/Home/GetSelectList?lookup=NormalMonth"
                );
                this.monthDDL = month;
                const { result: res } = await this.$http.fetchData(
                    "Forecast/GetMdrReport",
                    {
                        areaId: !this.searchList.areaId ? 0 : +this.searchList.areaId,
                        saleGroupId: !this.searchList.salegroupId
                            ? 0
                            : +this.searchList.salegroupId,
                        month: this.searchList.month,
                        year: this.searchList.year,
                        pageNumber: this.queryInfo.pagenum - 1,
                        pageSize: this.queryInfo.pagesize,
                        isExport: false
                    }
                );
                if (res.data.length > 0) {
                    res.data.forEach(e => {
                        e.isChanged = false;
                        e.originalsales = e.sales;
                        e.originalmdrAmount = e.mdrAmount;
                        e.originalrebatesReturnAmount = e.rebatesReturnAmount;
                        e.monthLabel = this.monthDDL.find(x => x.value == e.month).label;
                        if (e.sales > 0) {
                            e.mdrAmountPercent = this.convertDecimal(e.mdrAmount / e.sales * 100);
                            e.rebatesReturnAmountPercent = this.convertDecimal(e.rebatesReturnAmount / e.sales * 100);
                        } else {
                            e.mdrAmountPercent = 0;
                            e.rebatesReturnAmountPercent = 0;
                        }                        
                    });
                };                    
                if (!!res.data.length) {
                    this.mdrReportList = res.data;
                    this.listTotalNum = res.total[0].total;
                    this.totalSales = res.total[0].totalSales;
                    this.totalMdrAmount = res.total[0].mdrAmount;                    
                    this.totalRebetaAmount = res.total[0].rebatesReturnAmountAmount;
                    this.totalMdrAmountPercent = res.total[0].mdrPercent;
                    this.totalRebetaAmountPercent = res.total[0].rebatesReturnPercent;
                    this.tableShow = true;
                } else {
                    this.tableShow = false;
                    this.mdrReportList = [];
                    this.listTotalNum = 0;
                    this.$message.warning("没有对应的搜索数据");
                    this.totalSales = 0;
                    this.totalMdrAmount = 0;
                    this.totalRebetaAmount = 0;
                    this.totalMdrAmountPercent = 0;
                    this.totalRebetaAmountPercent = 0;
                }
            },
            handleSizeChange(newSize) {
                this.queryInfo.pagesize = newSize;
                this.getMdrReportList(false);
            },
            handleCurrentChange(newPage) {
                this.queryInfo.pagenum = newPage;
                this.getMdrReportList(false);
            },  
            editMDRReport() {
                if (this.isLoginUserAsAreaMarket == true) {
                    this.inputDisable = true;
                } else {
                    this.inputDisable = false;
                }
            },
            async saveMDRChange() {
                if (this.mdrReportList.filter(e => e.isChanged == true).length == 0) {
                    return this.$message.warning("没有任何数据更新，无需保存");
                }
                else {    
                    let updatemdrReportList = this.mdrReportList.filter(
                        e => e.isChanged == true
                    );                 
                    const { result: res } = await this.$http.fetchData(
                        "Forecast/UpdateMDRReport",
                        {
                            mdrReport: updatemdrReportList
                        }
                    );
                    if (res == "success") {
                        this.$message.success("保存MDR监控报告数据成功");
                        this.getMdrReportList(false);
                    } else {
                        this.$message.error("保存MDR监控报告数据失败");
                    }
                }
            },
            async exportMdrReportList() {
                const { result: fileName } = await this.$http.fetchData(
                    "Forecast/GetMdrReport",
                    {
                        areaId: !this.searchList.areaId ? 0 : +this.searchList.areaId,
                        saleGroupId: !this.searchList.salegroupId
                            ? 0
                            : +this.searchList.salegroupId,
                        month: this.searchList.month,
                        year: this.searchList.year,
                        pageNumber: this.queryInfo.pagenum - 1,
                        pageSize: this.queryInfo.pagesize,
                        isExport: true
                    }
                );
                this.downloadFileName = fileName;
                var todayDate = new Date();
                const res = await this.$http.downLoad(
                    `/Home/Download?fileName=${this.downloadFileName}`
                );
                var blob = new Blob([res.data], {
                    type:
                        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                });
                var objectUrl = URL.createObjectURL(blob);
                var a = document.createElement("a");
                a.setAttribute("style", "display:none");
                a.setAttribute("href", objectUrl);
                a.setAttribute(
                    "download",
                    `MDR监控报告_${todayDate.getFullYear()}${todayDate.getMonth() +
                    1}${todayDate.getDate()}_${todayDate.getHours()}${todayDate.getMinutes()}${todayDate.getSeconds()}.xlsx`
                );
                a.click();
                URL.revokeObjectURL(objectUrl);
            },

            importDialogClosed() {
                this.$refs.importFormRef.resetFields();
            },
            async submitUpload(param) {
                let file = this.$refs.upload.uploadFiles.pop().raw; //这里获取上传的文件对象
                let formData = new FormData();
                formData.append("file", file);
                formData.append("year", this.searchList.year);
                try {
                    const { result: res } = await this.$http.post(
                        "/Forecast/ImportMDRReport",
                        formData
                    );

                    if (res == "success") {
                        this.importDialogVisible = false;
                        return this.$message.success("上传成功");
                    } else if (res == "successMail") {
                        return this.$message.success(
                            "导入请求已被记录，后面会以邮件形式通知。"
                        );
                    } else if (res.errorType) {
                        return this.$message.error("上传失败：" + res.errorType);
                    } else if (!!res.errorFilePath) {
                        this.$notify({
                            title: "导入错误",
                            message: res.promptMessage,//"错误文件提示将自动下载，请查看",
                            type: "warning",
                            position: 'bottom-left'
                        });
                        var todayDate = new Date();
                        const errorFile = await this.$http.downLoad(
                            `/Home/Download?fileName=${res.errorFilePath}`
                        );
                        var blob = new Blob([errorFile.data], {
                            type:
                                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                        });
                        var objectUrl = URL.createObjectURL(blob);
                        var a = document.createElement("a");
                        a.setAttribute("style", "display:none");
                        a.setAttribute("href", objectUrl);
                        a.setAttribute(
                            "download",
                            `MDR报告导入失败_${todayDate.getFullYear()}${todayDate.getMonth() +
                            1}${todayDate.getDate()}.xlsx`
                        );
                        a.click();
                        URL.revokeObjectURL(objectUrl);
                    } else {
                        return this.$message.error("上传失败");
                    }
                } catch {
                    return this.$message.error("上传失败");
                }
            },
            handleSelectChange() {
                this.$forceUpdate();
            },
            getCurrentDate() {
                let date = new Date();
                this.currentYear = date.getFullYear(); //获取完整的年份(4位)
                this.searchList.year = this.currentYear;
                this.currentMonth = date.getMonth() + 1; //获取当前月份(0-11,0代表1月)
            },
            async areaChange() {
                if (!!this.searchList.areaId) {
                    this.searchList.salegroupId = null
                    const { result: sglist } = await this.$http.get(
                        `/Home/GetSelectListLinkage?lookup=salegroup&linkid=${this.searchList.areaId}`
                    );
                    this.saleGroupDDL = sglist;
                }
            },
            saleChange(row) {
                if (row.sales < 0 ) {
                    row.sales = row.originalsales;
                    this.$message.warning("毛销售不能小于0");
                }
                else {
                    row.originalsales = row.sales;
                    if (row.sales > 0) {
                        row.mdrAmountPercent = this.convertDecimal(row.mdrAmount / row.sales * 100);
                        row.rebatesReturnAmountPercent = this.convertDecimal(row.rebatesReturnAmount / row.sales * 100);
                    } else {
                        row.mdrAmountPercent = 0;
                        row.rebatesReturnAmountPercent = 0;
                    }
                    row.isChanged = true;
                }
            },
            mdrAmountChange(row) {
                if (row.mdrAmount < 0) {
                    row.mdrAmount = row.originalmdrAmount;
                    this.$message.warning("MDR总金额不能小于0");
                }
                else {
                    row.originalmdrAmount = row.mdrAmount;
                    if (row.sales > 0) {
                        row.mdrAmountPercent = this.convertDecimal(row.mdrAmount / row.sales * 100);
                        row.rebatesReturnAmountPercent = this.convertDecimal(row.rebatesReturnAmount / row.sales * 100);
                    } else {
                        row.mdrAmountPercent = 0;
                        row.rebatesReturnAmountPercent = 0;
                    }
                    row.isChanged = true;
                }
            },
            rebataAmountChange(row) {
                if (row.rebatesReturnAmount < 0) {
                    row.rebatesReturnAmount = row.originalrebatesReturnAmount;
                    this.$message.warning("消化返利终端总金额不能小于0");
                }
                else {
                    row.originalrebatesReturnAmount = row.rebatesReturnAmount;
                    if (row.sales > 0) {
                        row.mdrAmountPercent = this.convertDecimal(row.mdrAmount / row.sales * 100);
                        row.rebatesReturnAmountPercent = this.convertDecimal(row.rebatesReturnAmount / row.sales * 100);
                    } else {
                        row.mdrAmountPercent = 0;
                        row.rebatesReturnAmountPercent = 0;
                    }
                    row.isChanged = true;
                }
            }
        }
    };
</script>